import React from 'react';
import * as HeroIcons from '@heroicons/react/24/outline';
import * as HeroIconsSolid from '@heroicons/react/24/solid';

interface IconProps {
  name: keyof typeof HeroIcons | keyof typeof HeroIconsSolid;
  variant?: 'outline' | 'solid';
  size?: number;
  className?: string;
  onClick?: () => void;
  disabled?: boolean;
}

export default function Icon({
  name,
  variant = 'outline',
  size = 24,
  className = '',
  onClick,
  disabled = false,
}: IconProps) {
  const icons = variant === 'solid' ? HeroIconsSolid : HeroIcons;
  const IconComponent = icons[name as keyof typeof icons] as React.ElementType;

  if (!IconComponent) return null;

  return (
    <IconComponent
      width={size}
      height={size}
      className={className}
      onClick={disabled ? undefined : onClick}
      style={{ cursor: onClick && !disabled ? 'pointer' : undefined, opacity: disabled ? 0.4 : 1 }}
    />
  );
}